module.exports = __webpack_public_path__ + "static/media/clock-white.f97ffe90.svg";